import { render, staticRenderFns } from "./Polaroid.vue?vue&type=template&id=361e37af&scoped=true&"
import script from "./Polaroid.vue?vue&type=script&lang=ts&"
export * from "./Polaroid.vue?vue&type=script&lang=ts&"
import style0 from "./Polaroid.vue?vue&type=style&index=0&id=361e37af&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e37af",
  null
  
)

export default component.exports